module.exports = __webpack_public_path__ + "static/service-solar-5f308ba8186ba1016b83e778a20567cf.jpg";